import { PobSection, QuartermasterAction, QuartermasterState } from './types';

export const EMPTY_POB_SELECTION: Record<PobSection, string[]> = {
	onboard: [],
	expected: [],
	departing: [],
};

export const INITIAL_QUARTERMASTER_STATE: QuartermasterState = {
	sidebarState: {
		rigId: null,
		locationName: null,
		carrierId: null,
		carrierName: null,
	},
	drawerState: {
		addPobOpen: false,
		editPobOpen: false,
		editPobID: null,
	},
	searchValue: '',
	pobSearchInput: '',
	pobSearchValue: '',
	selectedPobIds: EMPTY_POB_SELECTION,
};

function clearPobSelection(state: QuartermasterState): QuartermasterState {
	return {
		...state,
		selectedPobIds: {
			onboard: [],
			expected: [],
			departing: [],
		},
	};
}

export function quartermasterReducer(
	state: QuartermasterState,
	action: QuartermasterAction
): QuartermasterState {
	switch (action.type) {
		case 'select-location': {
			if (state.sidebarState.rigId === action.id) {
				return {
					...clearPobSelection(state),
					sidebarState: INITIAL_QUARTERMASTER_STATE.sidebarState,
				};
			}

			return {
				...clearPobSelection(state),
				sidebarState: {
					rigId: action.id,
					locationName: action.name,
					carrierId: null,
					carrierName: null,
				},
			};
		}
		case 'select-transit': {
			const transitIsSelected = state.sidebarState.carrierId === action.id;
			return {
				...clearPobSelection(state),
				sidebarState: {
					...state.sidebarState,
					carrierId: transitIsSelected ? null : action.id,
					carrierName: transitIsSelected ? null : action.name,
				},
			};
		}
		case 'set-search':
			return { ...state, searchValue: action.value };
		case 'set-pob-search-input':
			return { ...state, pobSearchInput: action.value };
		case 'apply-pob-search':
			return { ...state, pobSearchValue: action.value };
		case 'set-add-pob-open':
			return {
				...state,
				drawerState: {
					...state.drawerState,
					addPobOpen: action.open,
				},
			};
		case 'set-edit-pob-open':
			return {
				...state,
				drawerState: {
					...state.drawerState,
					editPobOpen: action.open,
					editPobID: action.pobID ?? state.drawerState.editPobID,
				},
			};
		case 'toggle-pob-selection': {
			const sectionSelection = state.selectedPobIds[action.section];
			const isSelected = sectionSelection.includes(action.pobID);
			return {
				...state,
				selectedPobIds: {
					...state.selectedPobIds,
					[action.section]: isSelected
						? sectionSelection.filter((id) => id !== action.pobID)
						: [...sectionSelection, action.pobID],
				},
			};
		}
		case 'set-pob-selection':
			return {
				...state,
				selectedPobIds: {
					...state.selectedPobIds,
					[action.section]: [...action.pobIDs],
				},
			};
		case 'clear-pob-selection':
			if (action.section) {
				return {
					...state,
					selectedPobIds: {
						...state.selectedPobIds,
						[action.section]: [],
					},
				};
			}
			return clearPobSelection(state);
		default:
			return state;
	}
}
